/* eslint-disable @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-return, react-hooks/exhaustive-deps, @typescript-eslint/no-unsafe-argument, @typescript-eslint/no-explicit-any, @typescript-eslint/strict-boolean-expressions */

import { useCallback } from 'react';
import { Tick } from '../../types';
import useLog from 'hooks/useLog';
import { dayjs, ET } from 'util/shared/date';

export const filterLastDay = (values?: any) => {
  if (values == null) {
    return;
  }
  const days = new Set();
  const ticks = values
    .filter((v: any) => v.close != null)
    .map((v: any) => {
      const datetime = dayjs.tz(v.datetime, ET);
      days.add(datetime.format('YYYY-MM-DD'));
      return {
        price: parseFloat(v.close),
        epoch_millis: datetime.valueOf(),
      };
    });

  // Get all unique days as timestamps
  const daytimes: number[] = [...days.values()].map((ymd: any) =>
    dayjs(ymd).valueOf(),
  );

  // Find the most recent day's timestamp
  const lastDay = Math.max(...daytimes);

  // Filter to only include ticks from the most recent day
  return ticks.filter((v: Tick) => v.epoch_millis >= lastDay);
};

const useTimeSeries = () => {
  const { fetchAPIWithLog } = useLog('useTimeSeries');
  const getTimeSeries = useCallback(
    async (instruments: string[], reversed?: boolean, date?: string) => {
      const symbol = instruments.map(encodeURIComponent).join(',');
      return await fetchAPIWithLog(
        `v1/twelve_series?symbol=${symbol}&interval=1min&outputsize=390${
          reversed ? `&order=asc` : ''
        }${date ? `&date=${date}` : ''}`,
      );
    },
    [],
  );

  const getLastDaysPrices = useCallback(
    async (syms: string[], ascending?: boolean, date?: string) => {
      const data = await getTimeSeries(syms, ascending, date);
      const result: Record<string, Tick[]> = {};
      for (const sym in data) {
        result[sym] = filterLastDay(data[sym]?.values);
      }
      return result;
    },
    [],
  );

  return { getLastDaysPrices, getTimeSeries };
};

export default useTimeSeries;
